import { downloadFile } from './downloadFile';

/**
 * Always pass `fileName` with its extension (e.g. `report.png`).
 * `fileType` is the Blob's MIME — it does not control the saved filename.
 * Browsers only auto-append an extension when `fileName` has no dot, and even
 * then behavior is inconsistent across browsers. A dot anywhere in `fileName`
 * (e.g. from a user name like `D.J.Berg`) makes the browser treat everything
 * after the last dot as the extension.
 */
export const downloadBinaryFile = (
  data: BlobPart,
  fileType: BlobPropertyBag['type'],
  fileName: string,
) => {
  const blob = new Blob([data], { type: fileType });

  const url = URL.createObjectURL(blob);

  downloadFile(url, fileName);

  URL.revokeObjectURL(url);
};
